export enum LogActionsTypes {
  "LIST_LOG" = "LIST_LOG"
}

export enum LogMutationsTypes {
  "SET_LOG" = "SET_LOG"
}

export enum LogGettersTypes {
  "LOG_BY_ID" = "LOG_BY_ID",
  "LOG_ALL_ID" = "LOG_ALL_ID"
}
